$(document).ready(function() {
  // Handle incoming links with hashes
  if(window.location.hash) {
    var offsetTop = $(window.location.hash).offset().top - 70;
    $('html, body').animate({
      scrollTop: offsetTop
    }, 1000);
  }

  // Handle internal anchor link clicks
  $('a[href^="#"]').on('click', function(event) {
    var target = $(this.getAttribute('href'));
    if (target.length) {
      event.preventDefault();
      $('html, body').stop().animate({
        scrollTop: target.offset().top - 70
      }, 1000);
    }
  });
});
